import { render } from "./Shopping.vue?vue&type=template&id=3706164f"
import script from "./Shopping.vue?vue&type=script&lang=js"
export * from "./Shopping.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__